import type { KnowledgeStatus } from '@/types/knowledge'

export const KNOWLEDGE_STATUS_COLOR: Record<KnowledgeStatus, string> = {
  published: 'green',
  draft: 'blue',
  archived: 'default',
}

export const KNOWLEDGE_STATUS_LABEL: Record<KnowledgeStatus, string> = {
  published: '已发布',
  draft: '草稿',
  archived: '已归档',
}

export function canManageKnowledge(roles: string[]): boolean {
  return roles.includes('manager') || roles.includes('admin')
}
